import React, { Component } from "react";
import {
  Paper,
  Grid,
  CircularProgress,
  Checkbox,
  Tooltip,
} from "@material-ui/core";
import clsx from "clsx";
import { BulkEditDatePickerCustom } from "util/bulk-edit-input-elements/BulkEditDatePickerCustom";
import moment from "moment";
import DeselectableRadioGroup from "util/bulk-edit-input-elements/DeselectableRadioGroup";
import {
  bulkEditTextLength,
  bulkEditTextType,
  bulkEditOptionsType,
} from "redux/Types";
import BulkEditCustomSelect from "util/bulk-edit-input-elements/BulkEditCustomSelect";
import BulkEditTextInput from "util/bulk-edit-input-elements/BulkEditTextInput";
import CustomChipInput from "util/bulk-edit-input-elements/CustomChipInput";

export class TracksCommonUpdates extends Component {
  constructor(props) {
    super();
  }

  render() {
    const {
      classes,
      bulkEditData: {
        trackCommonEditing,
        job: { track_common_updates },
        validationErrors: { track_common_validation },
        sessionName,
      },
      handleTrackCommonValueChange,
      countries,
      origins,
      decades,
      vocals,
      loading,
      editTrackAppendValues,
      handleCommonTrackRefreshValues,
      handleTrackCommonAddChip,
      handleTrackCommonDeleteChip,
      // onChangeComposer,
      // onChangePublisher,
      onHandleCheckChange,
    } = this.props;

    const commonUpdate = track_common_updates;
    const errors = track_common_validation;
    return (
      <div>
        {(loading || !sessionName) && (
          <div className={classes.overlay}>
            <CircularProgress size={200} className={classes.bulkEditLoading} />
          </div>
        )}
        <>
          <Paper className={classes.globalCreateBody}>
            <Grid container className={classes.globalCreateInput}>
              <div>
                <div className={clsx(classes.globalCreateContentWrapper)}>
                  <Grid>
                    <Grid container spacing={12}>
                      <Grid item xs={4}>
                        <div className="fieldBlock">
                          <div
                            className={clsx(
                              "singleBlock ",
                              commonUpdate && commonUpdate.performer?.length > 0
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <CustomChipInput
                              id="performer"
                              name="performer"
                              title="Artist"
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.TEXT}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              onAdd={(chip) =>
                                handleTrackCommonAddChip(chip, "performer")
                              }
                              onDelete={(chip) =>
                                handleTrackCommonDeleteChip(chip, "performer")
                              }
                              value={
                                commonUpdate &&
                                commonUpdate.performer !== undefined
                                  ? commonUpdate.performer !== null
                                    ? commonUpdate.performer
                                    : []
                                  : trackCommonEditing &&
                                    trackCommonEditing.performer !== undefined
                                  ? trackCommonEditing.performer !== null
                                    ? trackCommonEditing.performer
                                    : []
                                  : []
                              }
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate &&
                                commonUpdate.recordLabel?.length > 0
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <CustomChipInput
                              id="recordLabel"
                              name="recordLabel"
                              title="Label"
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.TEXT}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              onAdd={(chip) =>
                                handleTrackCommonAddChip(chip, "recordLabel")
                              }
                              onDelete={(chip) =>
                                handleTrackCommonDeleteChip(chip, "recordLabel")
                              }
                              value={
                                commonUpdate &&
                                commonUpdate.recordLabel !== undefined
                                  ? commonUpdate.recordLabel !== null
                                    ? commonUpdate.recordLabel
                                    : []
                                  : trackCommonEditing &&
                                    trackCommonEditing.recordLabel !== undefined
                                  ? trackCommonEditing.recordLabel !== null
                                    ? trackCommonEditing.recordLabel
                                    : []
                                  : []
                              }
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={8}>
                        <div className="fieldBlock">
                          <div
                            className={clsx(
                              "singleBlock sixty",
                              commonUpdate && commonUpdate.composer?.length > 0
                                ? classes.edit_border_color
                                : "",
                              commonUpdate?.isUpdateComposer
                                ? classes.checkedEmptyValue
                                : ""
                            )}>
                            <CustomChipInput
                              id="composer"
                              name="composer"
                              title="Composer"
                              disabled={commonUpdate?.isUpdateComposer}
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.TEXT}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              onAdd={(chip) =>
                                handleTrackCommonAddChip(chip, "composer")
                              }
                              onDelete={(chip) =>
                                handleTrackCommonDeleteChip(chip, "composer")
                              }
                              value={
                                commonUpdate && commonUpdate.isUpdateComposer
                                  ? ["Make field Blank. Delete current values."]
                                  : commonUpdate &&
                                    commonUpdate.composer !== undefined
                                  ? commonUpdate.composer !== null
                                    ? commonUpdate.composer
                                    : []
                                  : trackCommonEditing &&
                                    trackCommonEditing.composer !== undefined
                                  ? trackCommonEditing.composer !== null
                                    ? trackCommonEditing.composer
                                    : []
                                  : []
                              }
                            />
                            <Tooltip
                              title="Make field blank. Delete current values."
                              arrow>
                              <Checkbox
                                name={"composerCheck"}
                                checked={
                                  commonUpdate &&
                                  commonUpdate.isUpdateComposer !== undefined
                                    ? commonUpdate.isUpdateComposer !== null
                                      ? commonUpdate.isUpdateComposer
                                      : false
                                    : trackCommonEditing &&
                                      trackCommonEditing.isUpdateComposer !==
                                        undefined
                                    ? trackCommonEditing.isUpdateComposer !==
                                      null
                                      ? trackCommonEditing.isUpdateComposer
                                      : false
                                    : false
                                }
                                onChange={(e) => {
                                  onHandleCheckChange(e, "composer");
                                }}
                              />
                            </Tooltip>
                          </div>
                          <div
                            className={clsx(
                              "singleBlock sixty",
                              commonUpdate &&
                                //commonUpdate.publisher ||
                                commonUpdate.publisher?.length > 0
                                ? classes.edit_border_color
                                : "",
                              commonUpdate?.isUpdatePublisher
                                ? classes.checkedEmptyValue
                                : ""
                            )}>
                            <CustomChipInput
                              id="publisher"
                              name="publisher"
                              title="Publisher"
                              disabled={commonUpdate?.isUpdatePublisher}
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.TEXT}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              onAdd={(chip) =>
                                handleTrackCommonAddChip(chip, "publisher")
                              }
                              onDelete={(chip) =>
                                handleTrackCommonDeleteChip(chip, "publisher")
                              }
                              value={
                                commonUpdate && commonUpdate.isUpdatePublisher
                                  ? ["Make field Blank. Delete current values."]
                                  : commonUpdate &&
                                    commonUpdate.publisher !== undefined
                                  ? commonUpdate.publisher !== null
                                    ? commonUpdate.publisher
                                    : []
                                  : trackCommonEditing &&
                                    trackCommonEditing.publisher !== undefined
                                  ? trackCommonEditing.publisher !== null
                                    ? trackCommonEditing.publisher
                                    : []
                                  : []
                              }
                            />
                            <Tooltip
                              title="Make field Blank. Delete current values."
                              arrow>
                              <Checkbox
                                name={"publisherCheck"}
                                checked={
                                  commonUpdate &&
                                  commonUpdate.isUpdatePublisher !== undefined
                                    ? commonUpdate.isUpdatePublisher !== null
                                      ? commonUpdate.isUpdatePublisher
                                      : false
                                    : trackCommonEditing &&
                                      trackCommonEditing.isUpdatePublisher !==
                                        undefined
                                    ? trackCommonEditing.isUpdatePublisher !==
                                      null
                                      ? trackCommonEditing.isUpdatePublisher
                                      : false
                                    : false
                                }
                                onChange={(e) => {
                                  onHandleCheckChange(e, "publisher");
                                }}
                              />
                            </Tooltip>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} spacing={12}>
                        <div
                          style={{ height: " 10px", display: "block" }}></div>
                      </Grid>
                      <Grid item xs={4}>
                        <div className="fieldBlock">
                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate &&
                                //commonUpdate.styles ||
                                commonUpdate.styles?.length > 0
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <CustomChipInput
                              id="styles"
                              name="styles"
                              title="Style"
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.TEXT}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              onAdd={(chip) =>
                                handleTrackCommonAddChip(chip, "styles")
                              }
                              onDelete={(chip) =>
                                handleTrackCommonDeleteChip(chip, "styles")
                              }
                              value={
                                commonUpdate &&
                                commonUpdate.styles !== undefined
                                  ? commonUpdate.styles !== null
                                    ? commonUpdate.styles
                                    : []
                                  : trackCommonEditing &&
                                    trackCommonEditing.styles !== undefined
                                  ? trackCommonEditing.styles !== null
                                    ? trackCommonEditing.styles
                                    : []
                                  : []
                              }
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.org_sky_Country
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditCustomSelect
                              id="org_sky_Country"
                              name="org_sky_Country"
                              title="Country"
                              titleClass={classes.bulkLabelRight}
                              disableUnderline
                              options={countries}
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_Country !== undefined
                                  ? commonUpdate.org_sky_Country !== null
                                    ? commonUpdate.org_sky_Country
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_Country !==
                                      undefined
                                  ? trackCommonEditing.org_sky_Country !== null
                                    ? trackCommonEditing.org_sky_Country
                                    : ""
                                  : ""
                              }
                              onChange={handleTrackCommonValueChange}
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_Country ||commonUpdate.org_sky_Country == "")? false: true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues(
                                  "org_sky_Country"
                                )
                              }
                              errors={track_common_validation}
                              classes={classes}
                              className={clsx(
                                classes.appbarSelect,
                                classes.advancedSearchMainDropdown,
                                errors?.org_sky_Country
                                  ? classes.customError
                                  : {}
                              )}
                            />
                            {errors && errors.org_sky_Country && (
                              <span
                                role="alert"
                                className={classes.appbarHideLabel}>
                                {errors.org_sky_Country}
                              </span>
                            )}
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.org_sky_Area
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditTextInput
                              id="org_sky_Area"
                              name="org_sky_Area"
                              title="Area"
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.TEXT}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              handleChange={(event) =>
                                handleTrackCommonValueChange(
                                  event,
                                  bulkEditTextLength.SMALL
                                )
                              }
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_Area !== undefined
                                  ? commonUpdate.org_sky_Area !== null
                                    ? commonUpdate.org_sky_Area
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_Area !==
                                      undefined
                                  ? trackCommonEditing.org_sky_Area !== null
                                    ? trackCommonEditing.org_sky_Area
                                    : ""
                                  : ""
                              }
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_Area ||commonUpdate.org_sky_Area == "")? false: true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("org_sky_Area")
                              }
                              errors={track_common_validation}
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.org_sky_RecordingYear
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditDatePickerCustom
                              name="org_sky_RecordingYear"
                              id="org_sky_RecordingYear"
                              title="Year"
                              titleClass={classes.bulkLabelRight}
                              arialabel="Year"
                              variant="inline"
                              format="yyyy"
                              margin="normal"
                              yearView={true}
                              // minDate={new Date(Date.now())}
                              classes={classes}
                              className={classes.tableFilterDateInputWithClear}
                              autoOk={true}
                              inputProps={{
                                "aria-label": "User Access Expiry Date",
                              }}
                              clearValueButton={true}
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_RecordingYear !== undefined
                                  ? commonUpdate.org_sky_RecordingYear
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_RecordingYear !==
                                      undefined
                                  ? trackCommonEditing.org_sky_RecordingYear
                                  : null
                              }
                              onChange={(event) => {
                                handleTrackCommonValueChange({
                                  target: {
                                    name: "org_sky_RecordingYear",
                                    type: "datetime",
                                    value: event
                                      ? moment(event).format("yyyy")
                                      : "",
                                  },
                                });
                              }}
                              onClearValueEvent={(event) => {
                                handleTrackCommonValueChange({
                                  target: {
                                    name: "org_sky_RecordingYear",
                                    type: "datetime",
                                    value: null,
                                  },
                                });
                              }}
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_RecordingYear ||commonUpdate.org_sky_RecordingYear == "")? false: true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues(
                                  "org_sky_RecordingYear"
                                )
                              }
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.org_sky_Decade
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditCustomSelect
                              id="org_sky_Decade"
                              name="org_sky_Decade"
                              title="Decade / Era"
                              titleClass={classes.bulkLabelRight}
                              disableUnderline
                              options={decades}
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_Decade !== undefined
                                  ? commonUpdate.org_sky_Decade !== null
                                    ? commonUpdate.org_sky_Decade
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_Decade !==
                                      undefined
                                  ? trackCommonEditing.org_sky_Decade !== null
                                    ? trackCommonEditing.org_sky_Decade
                                    : ""
                                  : ""
                              }
                              onChange={handleTrackCommonValueChange}
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_Decade ||commonUpdate.org_sky_Decade == "")? false: true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("org_sky_Decade")
                              }
                              errors={track_common_validation}
                              classes={classes}
                              className={clsx(
                                classes.appbarSelect,
                                classes.advancedSearchMainDropdown,
                                errors?.org_sky_Decade
                                  ? classes.customError
                                  : {}
                              )}
                            />
                          </div>
                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.prs
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditTextInput
                              id="prs"
                              name="prs"
                              title="Tunecode"
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.TEXT}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              handleChange={(event) =>
                                handleTrackCommonValueChange(
                                  event,
                                  bulkEditTextLength.SMALL
                                )
                              }
                              value={
                                commonUpdate && commonUpdate.prs !== undefined
                                  ? commonUpdate.prs !== null
                                    ? commonUpdate.prs
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.prs !== undefined
                                  ? trackCommonEditing.prs !== null
                                    ? trackCommonEditing.prs
                                    : ""
                                  : ""
                              }
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.prs ||commonUpdate.prs == "")? false: true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("prs")
                              }
                              errors={track_common_validation}
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div className="fieldBlock">
                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.musicOrigin
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditCustomSelect
                              id="musicOrigin"
                              name="musicOrigin"
                              title="Origin"
                              titleClass={classes.bulkLabelRight}
                              disableUnderline
                              options={origins}
                              value={
                                commonUpdate &&
                                commonUpdate.musicOrigin !== undefined
                                  ? commonUpdate.musicOrigin !== null
                                    ? commonUpdate.musicOrigin
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.musicOrigin !== undefined
                                  ? trackCommonEditing.musicOrigin !== null
                                    ? trackCommonEditing.musicOrigin
                                    : ""
                                  : ""
                              }
                              onChange={handleTrackCommonValueChange}
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.musicOrigin ||commonUpdate.musicOrigin == "")? false: true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("musicOrigin")
                              }
                              errors={track_common_validation}
                              classes={classes}
                              className={clsx(
                                classes.appbarSelect,
                                classes.advancedSearchMainDropdown,
                                errors?.musicOrigin ? classes.customError : {}
                              )}
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.org_sky_Vocal
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditCustomSelect
                              id="org_sky_Vocal"
                              name="org_sky_Vocal"
                              title="Vocal"
                              titleClass={classes.bulkLabelRight}
                              disableUnderline
                              options={vocals}
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_Vocal !== undefined
                                  ? commonUpdate.org_sky_Vocal !== null
                                    ? commonUpdate.org_sky_Vocal
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_Vocal !==
                                      undefined
                                  ? trackCommonEditing.org_sky_Vocal !== null
                                    ? trackCommonEditing.org_sky_Vocal
                                    : ""
                                  : ""
                              }
                              onChange={handleTrackCommonValueChange}
                              refreshDisabled={true}
                              // refreshDisabled={ commonUpdate &&(commonUpdate.org_sky_Vocal ||commonUpdate.org_sky_Vocal == "")? false: true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("org_sky_Vocal")
                              }
                              errors={track_common_validation}
                              classes={classes}
                              className={clsx(
                                classes.appbarSelect,
                                classes.advancedSearchMainDropdown,
                                errors?.org_sky_Vocal ? classes.customError : {}
                              )}
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.position
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditTextInput
                              id="position"
                              name="position"
                              title="Track No"
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.NUMBER}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              handleChange={(event) =>
                                handleTrackCommonValueChange(
                                  event,
                                  bulkEditTextLength.SMALL
                                )
                              }
                              value={
                                commonUpdate &&
                                commonUpdate.position !== undefined
                                  ? commonUpdate.position !== null
                                    ? commonUpdate.position
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.position !== undefined
                                  ? trackCommonEditing.position !== null
                                    ? trackCommonEditing.position
                                    : ""
                                  : ""
                              }
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.position ||commonUpdate.position == "")? false: true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("position")
                              }
                              errors={track_common_validation}
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.prodDiscNr
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditTextInput
                              id="prodDiscNr"
                              name="prodDiscNr"
                              title="Disk No"
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.NUMBER}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              handleChange={(event) =>
                                handleTrackCommonValueChange(
                                  event,
                                  bulkEditTextLength.SMALL
                                )
                              }
                              value={
                                commonUpdate &&
                                commonUpdate.prodDiscNr !== undefined
                                  ? commonUpdate.prodDiscNr !== null
                                    ? commonUpdate.prodDiscNr
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.prodDiscNr !== undefined
                                  ? trackCommonEditing.prodDiscNr !== null
                                    ? trackCommonEditing.prodDiscNr
                                    : ""
                                  : ""
                              }
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.prodDiscNr ||commonUpdate.prodDiscNr == "")? false: true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("prodDiscNr")
                              }
                              errors={track_common_validation}
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.tempo
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditTextInput
                              id="tempo"
                              name="tempo"
                              title="Tempo"
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.NUMBER}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              handleChange={(event) =>
                                handleTrackCommonValueChange(
                                  event,
                                  bulkEditTextLength.SMALL
                                )
                              }
                              value={
                                commonUpdate && commonUpdate.tempo !== undefined
                                  ? commonUpdate.tempo !== null
                                    ? commonUpdate.tempo
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.tempo !== undefined
                                  ? trackCommonEditing.tempo !== null
                                    ? trackCommonEditing.tempo
                                    : ""
                                  : ""
                              }
                              refreshDisabled={true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("tempo")
                              }
                              errors={track_common_validation}
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate && commonUpdate.numBpm
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditTextInput
                              id="numBpm"
                              name="numBpm"
                              title="BPM"
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.NUMBER}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              handleChange={(event) =>
                                handleTrackCommonValueChange(
                                  event,
                                  bulkEditTextLength.SMALL
                                )
                              }
                              value={
                                commonUpdate && commonUpdate.numBpm !== undefined
                                  ? commonUpdate.numBpm !== null
                                    ? commonUpdate.numBpm
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.numBpm !== undefined
                                  ? trackCommonEditing.numBpm !== null
                                    ? trackCommonEditing.numBpm
                                    : ""
                                  : ""
                              }
                              refreshDisabled={true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("numBpm")
                              }
                              errors={track_common_validation}
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div className="fieldBlock">
                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate &&
                                commonUpdate.org_sky_SingleChartPosition
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditTextInput
                              id="org_sky_SingleChartPosition"
                              name="org_sky_SingleChartPosition"
                              title="Single Chart Pos"
                              titleClass={classes.bulkLabelRight}
                              type={bulkEditTextType.NUMBER}
                              maxLength={bulkEditTextLength.SMALL}
                              classes={classes}
                              handleChange={(event) =>
                                handleTrackCommonValueChange(
                                  event,
                                  bulkEditTextLength.SMALL
                                )
                              }
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_SingleChartPosition !==
                                  undefined
                                  ? commonUpdate.org_sky_SingleChartPosition !==
                                    null
                                    ? commonUpdate.org_sky_SingleChartPosition
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_SingleChartPosition !==
                                      undefined
                                  ? trackCommonEditing.org_sky_SingleChartPosition !==
                                    null
                                    ? trackCommonEditing.org_sky_SingleChartPosition
                                    : ""
                                  : ""
                              }
                              refreshDisabled={true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues(
                                  "org_sky_SingleChartPosition"
                                )
                              }
                              errors={track_common_validation}
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate &&
                                commonUpdate.org_sky_SingleReleaseDate
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditDatePickerCustom
                              name="org_sky_SingleReleaseDate"
                              id="org_sky_SingleReleaseDate"
                              title="Single Release Date"
                              titleClass={classes.bulkLabelRight}
                              arialabel="Single Release Date"
                              variant="inline"
                              format="dd/MM/yyyy"
                              margin="normal"
                              // minDate={new Date(Date.now())}
                              classes={classes}
                              className={classes.tableFilterDateInputWithClear}
                              autoOk={true}
                              inputProps={{
                                "aria-label": "Single Release Date",
                              }}
                              clearValueButton={true}
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_SingleReleaseDate !==
                                  undefined
                                  ? commonUpdate.org_sky_SingleReleaseDate
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_SingleReleaseDate !==
                                      undefined
                                  ? trackCommonEditing.org_sky_SingleReleaseDate
                                  : null
                              }
                              onChange={(event) => {
                                handleTrackCommonValueChange({
                                  target: {
                                    name: "org_sky_SingleReleaseDate",
                                    type: "datetime",
                                    value: event
                                      ? moment(event).format("yyyy-MM-DD")
                                      : "",
                                  },
                                });
                              }}
                              onClearValueEvent={(event) => {
                                handleTrackCommonValueChange({
                                  target: {
                                    name: "org_sky_SingleReleaseDate",
                                    type: "datetime",
                                    value: null,
                                  },
                                });
                              }}
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_SingleReleaseDate ||commonUpdate.org_sky_SingleReleaseDate == "")? false : true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues(
                                  "org_sky_SingleReleaseDate"
                                )
                              }
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate &&
                                (commonUpdate?.org_sky_IsSingleRelease ===
                                  true ||
                                  commonUpdate?.org_sky_IsSingleRelease ===
                                    false)
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <DeselectableRadioGroup
                              ariaLabel="org_sky_IsSingleRelease"
                              name="org_sky_IsSingleRelease"
                              title="Single Release"
                              titleClass={classes.bulkLabelRight}
                              options={bulkEditOptionsType}
                              classes={classes}
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_IsSingleRelease !==
                                  undefined
                                  ? commonUpdate.org_sky_IsSingleRelease !==
                                    null
                                    ? commonUpdate.org_sky_IsSingleRelease
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_IsSingleRelease !==
                                      undefined
                                  ? trackCommonEditing.org_sky_IsSingleRelease !==
                                    null
                                    ? trackCommonEditing.org_sky_IsSingleRelease
                                    : ""
                                  : null
                              }
                              onChange={handleTrackCommonValueChange}
                              refreshDisabled={true}
                              // refreshDisabled={ commonUpdate &&(commonUpdate.org_sky_IsSingleRelease ||commonUpdate.org_sky_IsSingleRelease == "")? false: true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues(
                                  "org_sky_IsSingleRelease"
                                )
                              }
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate &&
                                (commonUpdate?.org_sky_DownloadAvailable ===
                                  true ||
                                  commonUpdate?.org_sky_DownloadAvailable ===
                                    false)
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <DeselectableRadioGroup
                              ariaLabel="org_sky_DownloadAvailable"
                              name="org_sky_DownloadAvailable"
                              title="Download Allowed"
                              titleClass={classes.bulkLabelRight}
                              options={bulkEditOptionsType}
                              classes={classes}
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_DownloadAvailable !==
                                  undefined
                                  ? commonUpdate.org_sky_DownloadAvailable !==
                                    null
                                    ? commonUpdate.org_sky_DownloadAvailable
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_DownloadAvailable !==
                                      undefined
                                  ? trackCommonEditing.org_sky_DownloadAvailable !==
                                    null
                                    ? trackCommonEditing.org_sky_DownloadAvailable
                                    : ""
                                  : null
                              }
                              onChange={handleTrackCommonValueChange}
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_DownloadAvailable || commonUpdate.org_sky_DownloadAvailable == "")?false:true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues(
                                  "org_sky_DownloadAvailable"
                                )
                              }
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate &&
                                (commonUpdate?.org_sky_IsLibraryRecommended ===
                                  true ||
                                  commonUpdate?.org_sky_IsLibraryRecommended ===
                                    false)
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <DeselectableRadioGroup
                              ariaLabel="org_sky_IsLibraryRecommended"
                              name="org_sky_IsLibraryRecommended"
                              title="Library Recommended"
                              titleClass={classes.bulkLabelRight}
                              options={bulkEditOptionsType}
                              classes={classes}
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_IsLibraryRecommended !==
                                  undefined
                                  ? commonUpdate.org_sky_IsLibraryRecommended !==
                                    null
                                    ? commonUpdate.org_sky_IsLibraryRecommended
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_IsLibraryRecommended !==
                                      undefined
                                  ? trackCommonEditing.org_sky_IsLibraryRecommended !==
                                    null
                                    ? trackCommonEditing.org_sky_IsLibraryRecommended
                                    : ""
                                  : null
                              }
                              onChange={handleTrackCommonValueChange}
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_IsLibraryRecommended || commonUpdate.org_sky_IsLibraryRecommended =="")?false:true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues(
                                  "org_sky_IsLibraryRecommended"
                                )
                              }
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate &&
                                (commonUpdate?.org_sky_PPL === true ||
                                  commonUpdate?.org_sky_PPL === false)
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <DeselectableRadioGroup
                              ariaLabel="org_sky_PPL"
                              name="org_sky_PPL"
                              title="Non-PPL"
                              titleClass={classes.bulkLabelRight}
                              options={bulkEditOptionsType}
                              classes={classes}
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_PPL !== undefined
                                  ? commonUpdate.org_sky_PPL !== null
                                    ? (commonUpdate.org_sky_PPL == true || commonUpdate.org_sky_PPL == 1) ? false 
                                    : (commonUpdate.org_sky_PPL == false || commonUpdate.org_sky_PPL == 0) ? true : null
                                    : ""
                                  : trackCommonEditing && trackCommonEditing.pplStatusMigrated != true ? null :
                                    trackCommonEditing && trackCommonEditing.org_sky_PPL !== undefined
                                  ? trackCommonEditing.org_sky_PPL !== null
                                    ? (trackCommonEditing.org_sky_PPL == true || trackCommonEditing.org_sky_PPL == 1) ? false
                                    : (trackCommonEditing.org_sky_PPL == false || trackCommonEditing.org_sky_PPL == 0) ? true : null
                                    : ""
                                  : null
                              }
                              
                              onChange={(event) => {
                                  var changes = { target : {name: event?.target?.name, value: (event?.target?.value != undefined
                                    && event?.target?.value != null) ? (event.target.value == true ? false : event.target.value == false ? true : null) : null }};
                                  handleTrackCommonValueChange(changes);
                                }}
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_PPL || commonUpdate.org_sky_PPL == "")?false:true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("org_sky_PPL")
                              }
                            />
                          </div>

                          <div
                            className={clsx(
                              "singleBlock",
                              commonUpdate &&
                                (commonUpdate?.org_sky_MCPS === true ||
                                  commonUpdate?.org_sky_MCPS === false)
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <DeselectableRadioGroup
                              ariaLabel="org_sky_MCPS"
                              name="org_sky_MCPS"
                              title="Non-MCPS"
                              titleClass={classes.bulkLabelRight}
                              options={bulkEditOptionsType}
                              classes={classes}
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_MCPS !== undefined
                                  ? commonUpdate.org_sky_MCPS !== null
                                    ? (commonUpdate.org_sky_MCPS == true || commonUpdate.org_sky_MCPS == 1) ? false 
                                    : (commonUpdate.org_sky_MCPS == false || commonUpdate.org_sky_MCPS == 0) ? true : null
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_MCPS !==
                                      undefined
                                  ? trackCommonEditing.org_sky_MCPS !== null
                                    ? (trackCommonEditing.org_sky_MCPS == true || trackCommonEditing.org_sky_MCPS == 1) ? false 
                                    : (trackCommonEditing.org_sky_MCPS == false || trackCommonEditing.org_sky_MCPS == 0) ? true : null
                                    : ""
                                  : null
                              }
                              onChange={(event) => { 
                                  var changes = { target : {name: event?.target?.name, value: (event?.target?.value != undefined
                                     && event?.target?.value != null) ? (event.target.value == true ? false : event.target.value == false ? true : null) : null }};
                                  handleTrackCommonValueChange(changes);
                                }}
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_MCPS || commonUpdate.org_sky_MCPS == "")?false:true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("org_sky_MCPS")
                              }
                            />
                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={6}>
                        <div
                          className={
                            editTrackAppendValues ? classes.border_color : ""
                          }>
                          <div
                            className={clsx(
                              "singleBlock flexBasis fullwidth",
                              commonUpdate && commonUpdate.trackNotes
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditTextInput
                              id="trackNotes"
                              name="trackNotes"
                              title="Notes"
                              titleClass={classes.bulkLabelTop}
                              type={bulkEditTextType.TEXT}
                              isAppend={true}
                              multiline
                              maxLength={bulkEditTextLength.LARGE}
                              rows={6}
                              classes={classes}
                              handleChange={(event) =>
                                handleTrackCommonValueChange(
                                  event,
                                  bulkEditTextLength.LARGE
                                )
                              }
                              value={
                                commonUpdate &&
                                commonUpdate.trackNotes !== undefined
                                  ? commonUpdate.trackNotes !== null
                                    ? commonUpdate.trackNotes
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.trackNotes !== undefined
                                  ? trackCommonEditing.trackNotes !== null
                                    ? trackCommonEditing.trackNotes
                                    : ""
                                  : ""
                              }
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.trackNotes || commonUpdate.trackNotes == "")?false:true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("trackNotes")
                              }
                              errors={track_common_validation}
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={6}>
                        <div
                          className={
                            editTrackAppendValues ? classes.border_color : ""
                          }>
                          <div
                            className={clsx(
                              "singleBlock flexBasis fullwidth",
                              commonUpdate &&
                                commonUpdate.org_sky_LibrarianNotes
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditTextInput
                              id="org_sky_LibrarianNotes"
                              name="org_sky_LibrarianNotes"
                              title="Librarian Notes"
                              titleClass={classes.bulkLabelTop}
                              type={bulkEditTextType.TEXT}
                              maxLength={bulkEditTextLength.LARGE}
                              isAppend={true}
                              multiline
                              rows={6}
                              classes={classes}
                              handleChange={(event) =>
                                handleTrackCommonValueChange(
                                  event,
                                  bulkEditTextLength.LARGE
                                )
                              }
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_LibrarianNotes !==
                                  undefined
                                  ? commonUpdate.org_sky_LibrarianNotes !== null
                                    ? commonUpdate.org_sky_LibrarianNotes
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_LibrarianNotes !==
                                      undefined
                                  ? trackCommonEditing.org_sky_LibrarianNotes !==
                                    null
                                    ? trackCommonEditing.org_sky_LibrarianNotes
                                    : ""
                                  : ""
                              }
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_LibrarianNotes || commonUpdate.org_sky_LibrarianNotes == "")?false:true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues(
                                  "org_sky_LibrarianNotes"
                                )
                              }
                              errors={track_common_validation}
                            />
                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={12}>
                        <div
                          className={
                            editTrackAppendValues ? classes.border_color : ""
                          }>
                          <div
                            className={clsx(
                              "singleBlock flexBasis fullwidth",
                              commonUpdate && commonUpdate.org_sky_Lyrics
                                ? classes.edit_border_color
                                : ""
                            )}>
                            <BulkEditTextInput
                              id="org_sky_Lyrics"
                              name="org_sky_Lyrics"
                              title="Lyrics"
                              titleClass={classes.bulkLabelTop}
                              type={bulkEditTextType.TEXT}
                              isAppend={true}
                              multiline
                              rows={6}
                              maxLength={bulkEditTextLength.LARGE}
                              classes={classes}
                              handleChange={(event) =>
                                handleTrackCommonValueChange(
                                  event,
                                  bulkEditTextLength.LARGE
                                )
                              }
                              value={
                                commonUpdate &&
                                commonUpdate.org_sky_Lyrics !== undefined
                                  ? commonUpdate.org_sky_Lyrics !== null
                                    ? commonUpdate.org_sky_Lyrics
                                    : ""
                                  : trackCommonEditing &&
                                    trackCommonEditing.org_sky_Lyrics !==
                                      undefined
                                  ? trackCommonEditing.org_sky_Lyrics !== null
                                    ? trackCommonEditing.org_sky_Lyrics
                                    : ""
                                  : ""
                              }
                              refreshDisabled={true}
                              //refreshDisabled={commonUpdate &&(commonUpdate.org_sky_Lyrics || commonUpdate.org_sky_Lyrics == "")?false:true}
                              refreshOnClick={() =>
                                handleCommonTrackRefreshValues("org_sky_Lyrics")
                              }
                              errors={track_common_validation}
                            />
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </Grid>
          </Paper>
        </>
      </div>
    );
  }
}

export default TracksCommonUpdates;
